import { Component, OnInit } from '@angular/core';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { ModalController } from '@ionic/angular';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';
import videojs from 'video.js';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-racing-roulette',
  templateUrl: './racing-roulette.component.html',
  styleUrls: ['./racing-roulette.component.scss'],
})
export class RacingRouletteComponent implements OnInit {

  rouletteVideoUrl: any;
  player: any;
  kironNewData: any; 
  Kiron2VideoUrl: any;
  is_logged = false;

  meetingPayload = {
    country: 'KR8',
    date: this.commanService.getCurrentDateTime(),
    filter: 1,
    inplay: false,
    sport: 'VR',
  }

  timerDisplay: string;
  NextDrowEventCode: string;
  CurrentEventName: string;
  // private timer: any;
  // private totalSeconds: number = 120;

  kironNumbers: any[] = [];
  kironPayload: any[] = [];   // eventSelection payload
  allNumbers: any[] = []; // Numbers
  row1: any[] = [];
  row2: any[] = [];
  row3: any[] = [];
  // new map that holds API selection object for special ids (R1, C1, Low, High, Red, Black, Odd, Even)
  specialMap: { [gridId: string]: { apiId: number, name: string, eventId: number, selectionNumber: number, meetingName: string, eventName: string, countryCode: string, clickedCount?: number } } = {};
  rowSelections: any = {};
  colSelections: any = {};
  rangeSelections: any = {};
  colorSelections: any = {};
  paritySelections: any = {};
  zeroNumber: any = null;
  selection: any = {
    "payload": {
      "@rule": "FeedId88BettingOptions",
      eventSelections: []
    }

  };
  clickCounts: { [key: string]: number } = {};
  maxCount = false;
  selectedBets = new Set<string>();
  selectedOtherOptionBets = new Set<string>();
  betSlips: string[] = [];
  disable_SP_subscription: Subscription;
  subscription: Subscription;
  mySubscription: Subscription;
  kironResults: any = [];

  currentSelectedBets: any = null;    // Block other races selections

  constructor(public modalController: ModalController, public betting_service: BettingServiceService, public translate: TranslateService,
    private commanService: CommonServiceService, private stmgService: StmgService, public alertController: AlertController) {

    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      this.clearAll();
    })

    this.stmgService.updateSelections$.subscribe((selection) => {
      if(selection){
        if(selection.selectionNumber >= 0 && selection.selectionNumber <=12){
          if(this.selectedBets.has(selection.selectionNumber.toString())){
            this.selectedBets.delete(selection.selectionNumber.toString());
          }
        }else{
          if(this.selectedOtherOptionBets.has(selection.name)){
            this.selectedOtherOptionBets.delete(selection.name);
          }
        }
      }
    });
  }

  ngOnInit() {
  
    // Subscribe to login status
    this.stmgService.is_logged_status.subscribe(message => {
      this.is_logged = message;
      // If logged in, initialize video player
      if (this.is_logged) {
        this.initVideoPlayer();
      }
    });

    // get Kiron Meetings
    this.kiron_getMeetings();

     this.get_kiron_results();

    // Block other races selections
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });
  }

  initVideoPlayer() {
    this.betting_service.getKiron8VideoUrl(this.commanService.getToken()).subscribe((res: any) => {

      // Adjust this according to your API response structure
      this.rouletteVideoUrl = res?.url || res?.videoUrl || res?.data?.url;

      if (!this.rouletteVideoUrl) {
        console.error('Video URL not found in response');
        return;
      }

      setTimeout(() => {
        if (this.player) {
          this.player.dispose();
        }

        this.player = videojs('video-player', {
          controls: true,
          autoplay: false,
          preload: 'auto',
          fluid: true,
          techOrder: ['html5'],
          html5: {
            hls: {
              overrideNative: true,
              withCredentials: false,
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false,
          },
        });

        this.player.src(
          this.rouletteVideoUrl.includes('.m3u8')
            ? { type: 'application/x-mpegURL', src: this.rouletteVideoUrl }
            : { type: 'video/mp4', src: this.rouletteVideoUrl }
        );

        this.player.load();
      }, 0);

    }, error => {
      console.error('Error getting video URL:', error);
    });
  }

  // Video click handler
  onVideoClick() {
    if (!this.is_logged) {
      let alertTitle: string;
      let alertDesc: string;

      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe(res => alertTitle = res);
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe(res => alertDesc = res);

      const alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }
  }

  //kiron result method
  get_kiron_results() {
    this.betting_service.getKiron8Result().subscribe(
      (data) => {
          this.kironResults = data[0].events;
          this.kironResults = this.kironResults.reverse();
          // console.log("RR results: ",  data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // get Kiron Meetings
  kiron_getMeetings() {
    this.betting_service.getRacingRouletMeetingDataById(this.meetingPayload).subscribe((data: any) => {
      this.kironGetEventStartTime(data.payload[0].eventLightDTOs);
      this.GetNextDrowEventCode(data.payload[0].eventLightDTOs);
      // console.log("Meeting Response Racing Roulete: ", data);
      this.kiron_data(data);
    });
  }

  GetNextDrowEventCode(data:any){
    this.NextDrowEventCode = data[0].eventCode;
  }

  // get 0th Item from eventLightDTOs
  kiron_data(d: any) {
    let kironMeetings_Data: any = null;
    if (d.status === 'success' && d.payload.length > 0) {
      const events = d.payload[0].eventLightDTOs;
      if (events && events.length > 0) {
        // Get only the 0th item
        kironMeetings_Data = events[0];
      }
    }
    this.getKironsEventByID(kironMeetings_Data);
    // console.log("0th Item from eventLightDTOs:", kironMeetings_Data);
  }

  // Get event selections and map numbers
  getKironsEventByID(event: any) {
    if (!event?.id) {
      console.log("Invalid event data");
      return;
    }

    this.betting_service.getEventSelections(event.id).subscribe((data: any[]) => {
      this.GetEventName(data);
      this.allNumbers = data
        .filter(sel => typeof sel.selectionNumber === 'number' && sel.name && !/^(R|C|Low|High|Odd|Even|Red|Black)$/i.test(sel.name))
        .map(sel => {
          const number = sel.selectionNumber.toString();
          const color = sel.name.includes("(Red)") ? "red" :
            sel.name.includes("(Black)") ? "black" :
              sel.name.includes("(Green)") ? "green" : "";

          return {
            apiId: sel.id,
            id: number, // use number as id
            label: number,
            color,
            name: sel.name,
            eventId: sel.eventId,
            selectionNumber: sel.selectionNumber,
            meetingName: sel.meetingName,
            eventName: sel.eventName,
            countryCode: sel.countryCode,
          };
        });

      // number id set (include "0")
      this.NUMBER_IDS = new Set<string>([...this.allNumbers.map(n => n.id), '0']);

      // zero number object
      this.zeroNumber = this.allNumbers.find(n => n.id === "0");

      // build grid rows (1..12)
      const nums = this.allNumbers.filter(n => n.id !== "0");
      this.row1 = nums.filter(n => ["3", "6", "9", "12"].includes(n.id));
      this.row2 = nums.filter(n => ["2", "5", "8", "11"].includes(n.id));
      this.row3 = nums.filter(n => ["1", "4", "7", "10"].includes(n.id));

      this.specialMap = {}; // reset

      data.forEach(sel => {
        const rawName = (sel.name || '').trim();

        // Normalize: First letter capital
        const key =
          rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase();

        const isPureNumber = /^\d+$/.test(rawName);
        const startsWithNum = /^\d+\s*\(/.test(rawName);

        const specialList = [
          'R1', 'R2', 'R3', 'R4',
          'C1', 'C2', 'C3',
          'Low', 'High', 'Odd', 'Even', 'Black', 'Red'
        ];

        const isSpecial =
          !isPureNumber &&
          !startsWithNum &&
          specialList.includes(key);

        // Only special selections go to specialMap
        if (isSpecial) {
          this.specialMap[key] = {
            apiId: sel.id,
            name: sel.name,
            eventId: sel.eventId,
            selectionNumber: sel.selectionNumber,
            meetingName: sel.meetingName,
            eventName: sel.eventName,
            countryCode: sel.countryCode,
            clickedCount: 0
          };
        }
      });
    }, err => {
      console.error('getEventSelections error', err);
    });
  }

  GetEventName(data: any){

    this.CurrentEventName = data[0].eventName;

  }

  // Get event start time.
  kironGetEventStartTime(meeting) {
    this.betting_service.eventStartTime(meeting[0].id).subscribe((data) => {
      this.kironEventStartTime(data);
    }
    );
  }

  // Next draw time for used
  // kironEventStartTime(data) {
  //   let time = Math.round(data.timeToStartMillis / 1000);

  //   this.timerDisplay = this.formatTime(time);

  //   this.mySubscription = interval(1000).subscribe(() => {

  //     if (time <= 0) {
  //       this.timerDisplay = "00:00";
  //       this.mySubscription.unsubscribe();
  //       this.kiron_getMeetings();
  //       this.resetAllSelections();
  //       return;
  //     }

  //     time--;
  //     this.timerDisplay = this.formatTime(time);
  //   });
  // }


  kironEventStartTime(data) {
  let time = Math.round(data.timeToStartMillis / 1000);

  // clamp starting value
  time = Math.max(time, 0);

  this.timerDisplay = this.formatTime(time);

  // clear previous timer
  if (this.mySubscription) {
    this.mySubscription.unsubscribe();
  }

  this.mySubscription = interval(1000).subscribe(() => {

    time = time - 1;
    time = Math.max(time, 0);  // <-- VERY IMPORTANT

    this.timerDisplay = this.formatTime(time);

    if (time === 0) {
      this.mySubscription.unsubscribe();
      this.kiron_getMeetings();
      this.resetAllSelections();
      return;
    }

  });
}



  // For kironEventStartTime
  resetAllSelections() {
    this.selectedBets.clear();
    this.selectedOtherOptionBets.clear();
    this.betSlips = [];
    // Clear payload eventSelections safely
    if (this.selection && this.selection.payload && this.selection.payload.eventSelections) {
      this.selection.payload.eventSelections = [];
    }
    
    // Reset to initial state
    this.selection = {
      "payload": {
        "@rule": "FeedId88BettingOptions",
        eventSelections: []
      }
    };

    const empty_array = {
      eventSelections: []
    };
    
    this.clickCounts = {};
    // this.stmgService.updateSelecteBets(this.selection);
    this.stmgService.updateSelecteBets(empty_array);
  }

  // Time format
  private formatTime(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  
  //stop the loop
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose(); // clean up
    }
    this.mySubscription?.unsubscribe();
    this.disable_SP_subscription.unsubscribe();
  }

  // Push selections for bet slips eventSelection
  private pushSelection(selId: string) {
    // ---------- NUMBER ----------
    if (this.NUMBER_IDS.has(selId)) {
      const numObj = this.allNumbers.find(n => n.id === selId);
      // console.log('Found number object: ', numObj);

      if (!numObj) {
        console.log('Number object not found, returning');
        return;
      }

      const selectionObj = {
        id: numObj.apiId,
        eventCode: numObj.eventId,
        meetingName: numObj.meetingName,
        name: numObj.name,
        eventName: numObj.eventName,
        countryCode: numObj.countryCode,
        selectionNumber: numObj.selectionNumber,
      };
      // console.log('Created number selection object for Racing Roulette eventSelections: ', selectionObj);

      // Each number gets its own payload entry
      // const payload = {
      //   selections: [selectionObj]
      // };
      // console.log('Pushing number payload to Racing Roulette eventSelection: ', selectionObj);

      this.selection.payload.eventSelections.push(selectionObj);

      // console.log('Current Racing Roulette eventSelection: ', this.selection.payload.eventSelections);
      return;
    }

    // ---------- SPECIAL ----------
    const normalizedId = selId.charAt(0).toUpperCase() + selId.slice(1).toLowerCase();
    const special = this.specialMap[normalizedId];
    // console.log('Found special object: ', special);

    if (!special) {
      console.log('Special object not found, returning');
      return;
    }

    const selectionObj = {
      id: special.apiId,
      eventCode: special.eventId,
      meetingName: special.meetingName,
      name: special.name,
      eventName: special.eventName,
      countryCode: special.countryCode,
      selectionNumber: special.selectionNumber,
    };
    // console.log('Created special selection object for Racing Roulette eventSelections: ', selectionObj);

    // Each special gets its own payload entry
    // const payload = {
    //   selections: [selectionObj]
    // };
    // console.log('Pushing special payload to Racing Roulette eventSelection: ', selectionObj);

    this.selection.payload.eventSelections.push(selectionObj);

    // console.log('Current Racing Roulette eventSelection: ', this.selection.payload.eventSelections);
  }

  
  // Racing Roulette
  // Initialize NUMBER_IDS with roulette numbers 0-36
  private NUMBER_IDS = new Set<string>(
    Array.from({ length: 37 }, (_, i) => String(i))
  );
  private ROW_IDS = new Set<string>(['R1', 'R2', 'R3', 'R4']);
  private COL_IDS = new Set<string>(['C1', 'C2', 'C3']);
  private RANGE_IDS = new Set<string>(['low', 'high']);
  private COLOR_IDS = new Set<string>(['red', 'black']);
  private PARITY_IDS = new Set<string>(['odd', 'even']);

  // SINGLE TOTAL LIMIT = 4
  private MAX_TOTAL_SELECTIONS = 4;
  private MAX_SPECIAL_CLICKS = 3; // per special button

  // Helpers
  private groupOf(id: string): 'number' | 'row' | 'col' | 'range' | 'color' | 'parity' | 'other' {
    const normalized = String(id).toLowerCase();

    if (this.NUMBER_IDS.has(String(id))) return 'number';
    if (this.ROW_IDS.has(id)) return 'row';
    if (this.COL_IDS.has(id)) return 'col';
    if (this.RANGE_IDS.has(normalized)) return 'range';
    if (this.COLOR_IDS.has(normalized)) return 'color';
    if (this.PARITY_IDS.has(normalized)) return 'parity';
    return 'other';
  }

  private countNumberSelections(): number {
    return this.selectedBets.size;
  }

  private countSpecialSelections(): number {
    if (!Array.isArray(this.selection.payload?.eventSelections)) return 0;
    const totalEntries = this.selection.payload.eventSelections.length;
    const numberSelections = this.selectedBets.size;
    return totalEntries - numberSelections;
  }

  getChipCount(id: string): number {
    // if (this.NUMBER_IDS.has(id)) return this.selectedBets.has(id) ? 1 : 0;
    // return this.clickCounts[id] || 0;

    if(this.selectedBets.has(id) || this.selectedOtherOptionBets.has(id)){
      return 1 ;
    }

    return 0;
  }

  isSelected(id: string): boolean {
    // if (this.NUMBER_IDS.has(id)) return this.selectedBets.has(id);
    // return (this.clickCounts[id] && this.clickCounts[id] > 0) || false;
    if(this.selectedBets.has(id) || this.selectedOtherOptionBets.has(id)){
      return true;
    }

    return false;
  }
  
  // TOGGLE SELECTION
  toggleSelection(id: string) {

    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    // Block other races selections
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      // console.log('Racing Roulette - Inside check, currentBets exists');

      let hasPayload;

      if(this.currentSelectedBets?.payload){
        hasPayload = this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' ? true : false;
      }else{
        hasPayload = false;
      }
      
      // console.log('Has RR Selections :', hasPayload);
      
      if (!hasPayload) {
        let hasRaceBets;

        if(this.currentSelectedBets?.payload){
          hasRaceBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        }else{
          hasRaceBets = this.currentSelectedBets.eventSelections.length > 0;
        }
        
        // console.log('Game - Has Racing or other game Bets:', hasRaceBets);
        
        if (hasRaceBets) {
          this.showBlockAlert();
          return;
        }
      }
    }
    
    const grp = this.groupOf(id);

    const numberCount = this.countNumberSelections();
    const specialCount = this.countSpecialSelections();
    const total = numberCount + specialCount;

    // -------- NUMBER --------
    if (grp === 'number') {

      const already = this.selectedBets.has(id);

      if (already) {
        console.log('BLOCKED: Number already selected');
        return;
      }

      // TOTAL LIMIT CHECK
      if (!already && total >= this.MAX_TOTAL_SELECTIONS) {
        console.log('BLOCKED: Max total 4 reached');
        this.showMaxCountAlert();
        return;
      }

      // Add new number selection only ONCE
      this.selectedBets.add(id);

      if (!this.betSlips.includes(id)) {
        this.betSlips.push(id);
      }

      this.pushSelection(id);

      // console.log("Rcaing Roulette Selections: ", this.selection);

      this.stmgService.updateSelecteBets(this.selection);
      // if (this.selectedBets.size === 0 && this.countSpecialSelections() === 0) {
      //   this.stmgService.setSelectionStarted(false, null);
      // }
      return;
    }

    const already = this.selectedOtherOptionBets.has(id);

    if (already) {
        console.log('BLOCKED: specila one already selected');
        return;
    }


    // -------- SPECIAL --------
    if (!this.clickCounts[grp]) this.clickCounts[grp] = 0;

    if (this.clickCounts[grp] >= this.MAX_SPECIAL_CLICKS) {
      this.showOnlyOneThreeClickAlert();
      return;
    }

    // TOTAL LIMIT CHECK
    if (total >= this.MAX_TOTAL_SELECTIONS) {
      console.log('BLOCKED: Max total 4 reached');
      this.showMaxCountAlert();
      return;
    }

    // Increase click count
    this.clickCounts[grp]++;

    this.selectedOtherOptionBets.add(id);

    this.pushSelection(id);

    if (!this.betSlips.includes(id) && this.betSlips.length < this.MAX_TOTAL_SELECTIONS) {
        this.betSlips.push(id);
    }

    this.stmgService.updateSelecteBets(this.selection);
    return;
  
  }

  // REMOVE FROM SELECTION 
  private removeFromSelection(gridId: string) {
    if (!Array.isArray(this.selection.payload?.eventSelections)) return;

    const gridKey = String(gridId);

    // NUMBER remove 
    if (this.NUMBER_IDS.has(gridKey)) {
      const idx = this.selection.payload.eventSelections.findIndex((p: any) => {
        const sel = p?.selections?.[0];
        return !!sel && String(sel.selectionNumber) === gridKey;
      });
      if (idx !== -1) this.selection.payload.eventSelections.splice(idx, 1);
      return;
    }

    // SPECIAL remove 
    const normalizedId =
      gridKey.charAt(0).toUpperCase() + gridKey.slice(1).toLowerCase();

    const special = this.specialMap[normalizedId];

    if (!special) {
      const idxFallback = this.selection.payload.eventSelections.findIndex((p: any) => {
        const sel = p?.selections?.[0];
        return !!sel && String(sel.id) === gridKey;
      });

      if (idxFallback !== -1)
        this.selection.payload.eventSelections.splice(idxFallback, 1);

      return;
    }

    const specialApiId = String(special.apiId);

    const idx = this.selection.payload.eventSelections.findIndex((p: any) => {
      const sel = p?.selections?.[0];
      return !!sel && String(sel.id) === specialApiId;
    });

    if (idx !== -1) this.selection.payload.eventSelections.splice(idx, 1);
  }

  //  REMOVE FROM BETSLIP 
  private removeFromBetSlips(gridId: string) {
    this.betSlips = this.betSlips.filter(b => b !== gridId);
  }

  clearAll() {
    this.selectedBets.clear();
    this.selectedOtherOptionBets.clear();
    this.betSlips = [];
    // Clear payload eventSelections safely
    if (this.selection && this.selection.payload && this.selection.payload.eventSelections) {
      this.selection.payload.eventSelections = [];
    }
    
    // Reset to initial state
    this.selection = {
      "payload": {
        "@rule": "FeedId88BettingOptions",
        eventSelections: []
      }
    };
    this.clickCounts = {};

    const empty_array = {
      eventSelections: []
    };

    this.stmgService.updateSelecteBets(empty_array);
  }

  loginAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.PLEASE_LOG.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.PLEASE_LOG.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert(
      "", alertTitle, alertDesc
    );
  }

  // Max count
  checkMaximuSelectionCount(): boolean {
    const selectionArray = this.selection.payload.eventSelections.filter((m: any) => {
      return this.allNumbers.some((n: any) => n.id === m.id) || m.id === '0';
    });
    return selectionArray.length >= 8;
  }

  // Alerts
  showMaxCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  showOnlyOneThreeClickAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT_RR.TITLE').subscribe(res => alertTitle = res);
    this.translate.get('ALERTS.MAX_COUNT_RR.DESC').subscribe(res => alertDesc = res);
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  // Block Other Races
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }
}


